import React from 'react'
import './App.css';
import { BrowserRouter } from 'react-router-dom'
import Routes from './routes/routes'
import Header from './header'
import './tailwind.generated.css'

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes />
    </BrowserRouter>
  );
}

export default App;
